import React, {forwardRef} from 'react'
import classnames from 'classnames'

// @ts-ignore
import styles from './Textarea.scss'

type TextareaProps = JSX.IntrinsicElements['textarea'] & {
  rows?: number
  isError?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({isError = false, rows = 10, ...props}, ref) => {
    const textareaClassNames = isError ? [styles.textarea, styles.invalid] : [styles.textarea]

    return (
      <textarea
        ref={ref}
        rows={rows}
        {...props}
        className={classnames(textareaClassNames, props.className)}
      />
    )
  }
)
